module.exports = __webpack_public_path__ + "img/goat.27439bf8.svg";